module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_heading-ashinagasan2501-pc-208bc005ebc0e9ec8f058169cdeec36b.png";